import React from 'react';

interface KeyboardKeyProps {
    hebrewLetter: string;
    englishLetter: string;
    isActive: boolean;
    onClick: () => void;
    isFaded?: boolean;
    onKeyRef?: (element: HTMLButtonElement | null) => void;
}

export const KeyboardKey: React.FC<KeyboardKeyProps> = ({ 
    hebrewLetter, 
    englishLetter, 
    isActive, 
    onClick,
    isFaded = false,
    onKeyRef
}) => {
    // Only treat phones as mobile, not tablets  
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && window.innerWidth < 768;
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
    
    return (
    <button
        ref={onKeyRef}
        onClick={onClick}
        style={{
            position: 'relative',
            padding: isMobile ? '8px' : '16px', // Same padding for tablets and desktop
            margin: isMobile ? '1px' : '0px', // No margin - using CSS gap instead
            borderRadius: '6px',
            border: `2px solid ${isActive ? '#fbbf24' : '#374151'}`,
            backgroundColor: isActive ? '#fbbf24' : '#1f2937',
            cursor: 'pointer',
            transition: 'all 0.3s',
            transform: isActive ? 'scale(1.15)' : 'scale(1)',
            boxShadow: isActive 
                ? '0 0 20px rgba(251, 191, 36, 0.6), 0 10px 25px rgba(0,0,0,0.3)' 
                : '0 2px 4px rgba(0,0,0,0.3)',
            minWidth: isMobile ? '38px' : (isTablet ? '70px' : '60px'), // Bigger keys for tablets  
            minHeight: isMobile ? '38px' : (isTablet ? '70px' : '60px'),
            animation: isActive ? 'bounce 1s ease-in-out infinite' : 'none',
            opacity: isFaded ? 0.2 : 1
        }}
    >
        <div style={{
            position: 'absolute',
            top: isMobile ? '4px' : '6px',
            left: isMobile ? '6px' : '8px',
            fontSize: isMobile ? '14px' : '18px', // Same font size for tablets and desktop
            fontWeight: 'bold',
            color: isActive ? '#1f2937' : '#9ca3af'
        }}>
            {englishLetter === 'SPACE' ? 'SPACE' : englishLetter}
        </div>

        <div style={{
            position: 'absolute',
            bottom: isMobile ? '4px' : '6px',
            right: isMobile ? '6px' : '8px',
            fontSize: isMobile ? '20px' : '28px', // Same font size for tablets and desktop
            fontWeight: 'bold',
            color: isActive ? '#1f2937' : '#ffffff'
        }}>
            {hebrewLetter}
        </div>

        {isActive && (
            <div 
                style={{
                    position: 'absolute',
                    bottom: '-24px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '28px',
                    height: '28px',
                    backgroundColor: '#7c3aed',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    animation: 'fingerBounce 1s ease-in-out infinite'
                }}
            >
                <span style={{ color: 'white', fontSize: '16px' }}>👆</span>
            </div>
        )}
    </button>
    );
};